export const LOGOUT_EVENT = 'logout-event';
